<template>
  <div>
    <apexchart type="pie" width="400" :options="chartOptions" :series="series" v-if="isMobile"></apexchart>
    <apexchart type="pie" width="500" :options="chartOptions" :series="series" v-else></apexchart>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
    props: {
        breachTypes: Array,
        countSeismic : Number,
        countNoise : Number,
        countParticle : Number,
        countHzdGas : Number,
        countWeather : Number,
        isMobile: Boolean
    },

    data() {
        return {
            series: [this.countSeismic, this.countNoise, this.countParticle, this.countHzdGas, this.countWeather],
             chartOptions: {
            chart: {
              width: '100%',
              type: 'pie',
              foreColor: 'grey',
            },
            labels: this.breachTypes,
            responsive: [{
              breakpoint: 280,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'right',

                }
              }
            }]
          },
        }
    }
}
</script>
